import  React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { compose } from 'redux';

import ModalSelect from '@components/ProcessFrom/ModalSelect'
import ModalInputText from '@components/ProcessFrom/ModalInputText'
import ModalCheckboxCm from '@components/ProcessFrom/ModalCheckboxCm'

import { createCheckboxCm } from '@utils/digitalForm'

import './style.scss'

class EditorHtml extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModalSelect : {
        isVisible: false
      },
      showModalInputText : {
        isVisible: false
      },
      showModalCheckboxCm : {
        isVisible: false
      }
    };
  }

  componentDidMount () {
    const { htmlValue, isEdit } = this.props
    if (htmlValue) {

      document.getElementById("editorHtmlContent").innerHTML = htmlValue

      if (isEdit) {
        const elementEdit = document.getElementById("editorHtmlContent")
  
        const getInputs = elementEdit.getElementsByTagName('input')
        this.setPropertiesContextMenu(getInputs)
        const getSelect = elementEdit.getElementsByTagName('select')
        this.setPropertiesContextMenu(getSelect)
        const getTextArea = elementEdit.getElementsByTagName('textarea')
        this.setPropertiesContextMenu(getTextArea)
        const getChecksCustom = elementEdit.querySelectorAll('span.checkmark')
        this.setPropertiesContextMenu(getChecksCustom)
  
        // Desabilitar click en checkbox
        const getLabelCbCustom2 = elementEdit.querySelectorAll('label.cbCustom2')
        this.validateOnFocusCheckbox(getLabelCbCustom2)
  
  
        // elementEdit.addEventListener("keydown", this.onkeydownInEditable);
        // elementEdit.addEventListener("paste", this.onpaste);
        elementEdit.addEventListener("keydown", this.blockedRemoveItems)
        // Se deshabilita evento para mover elementos dentro del editor
        elementEdit.addEventListener('dragstart', function(e) {e.preventDefault();})
  
        // formateo de texto para pegado
        elementEdit.addEventListener("paste", function(e) {
          e.preventDefault();
          const text = (e.originalEvent || e).clipboardData.getData('text/plain');
          document.execCommand("insertHTML", false, text);
        });
      }


      // document.querySelectorAll('.cbCustom2').click(function (e) {
      //   console.log('click ---->')
      //   e.preventDefault();
      // })
    }
  }

  setPropertiesContextMenu = (options) => {
    if(options.length) {
      for (let i = 0; i < options.length; i += 1) {
        options[i].oncontextmenu = (e) => this.handleClick(e)
      }
    }
  }

  validateOnFocusCheckbox = (options) => {
    if(options.length) {
      for (let i = 0; i < options.length; i += 1) {
        options[i].onclick = (e) => {
          e.preventDefault();
        }
      }
    }
  }

  blockedRemoveItems = (e) => {
    console.log('Test', e)
    
    
    if (e.key === "Enter") {
      e.preventDefault();
    }
    // if (e.keyCode === 81) { Bloquear signos 
    //   e.preventDefault();
    // }
    if (e.key === "Backspace" || e.key === "Delete" || e.key === "Paste" || e.code === "Space") {
      const selection = window.getSelection();
      console.log('selection', selection)
      // Don't allow deleting nodes
      if (selection.focusOffset <= 0)  e.preventDefault()
      if (!selection.anchorNode.isSameNode(selection.focusNode)) e.preventDefault();
    }
  }


  onInputChange = (e) => {
    const { onChange } = this.props
    return onChange(e.currentTarget.firstChild)
  }


  handleClick = (e) => {
    e.preventDefault()
    if (e.type === 'contextmenu') {
      this.validateTagSelected(e)
    }
  };

  validateTagSelected = (e) => {
    if (e.target.tagName === "SELECT") return this.onSelect(e)
    if (e.target.tagName === "TEXTAREA" ) return this.onInputText(e)
    if (e.target.tagName === "INPUT" && e.target.getAttribute('type') === 'text') return this.onInputText(e)
    // if (e.target.tagName === "INPUT" && e.target.getAttribute('type') === 'radio') return this.onInputRadio(e)
    if (e.target.tagName === "INPUT" && e.target.getAttribute('type') === 'checkbox') return this.onInputChecbox(e)
    if (e.target.tagName === "SPAN" && e.target.className === 'checkmark') return this.onInputChecbox(e)
    return true
  }

  onSelect = (e) => {
    const { onChange, replicToOthersTemplates } = this.props
    this.setState({
      showModalSelect: {
        isVisible: true,
        target: e.target,
        editAction: ({optionsSelect}) => {
          let isEditValues = false
          for (let i = 0; i < e.target.options.length; i += 1) {
            e.target.options[i].text = optionsSelect[i].text
            if (e.target.options[i].value !== optionsSelect[i].value) {
              isEditValues = true
              e.target.options[i].value = optionsSelect[i].value
            }
          }
          
          onChange(document.getElementById("editorHtmlContent").firstChild)
          if (isEditValues) replicToOthersTemplates({e, type: 'select-values', options: {optionsSelect}})
        },
        addAction: (newText, newValue) => {
          const option = document.createElement( 'option' );
          option.value = newValue;
          option.text = newText;
          e.target.add( option );
          onChange(document.getElementById("editorHtmlContent").firstChild)
          replicToOthersTemplates({e, type: 'select-add', options: {newValue, newText}})
        },
        deleteAction: ({deleteOptionsSelect}) => {
          const allOptions =  e.target.getElementsByTagName('OPTION');
          for (let i =  e.target.length - 1; i >= 0; i--){
            const isExist = deleteOptionsSelect.find(item => item.value ===  e.target.options[i].value)
            if (!isExist) {
              e.target.removeChild( allOptions[i]);
            }
          }
          onChange(document.getElementById("editorHtmlContent").firstChild)
          replicToOthersTemplates({e, type: 'select-delete', options: {deleteOptionsSelect}})
        }
      }
    })
  }

  onInputText = (e) => {
    const { onChange } = this.props
    this.setState({
      showModalInputText: {
        isVisible: true,
        target: e.target,
        continueAction: ({placeHolder, minLength, maxLength}) => {
          e.target.placeholder = placeHolder
          if (minLength) e.target.minLength = minLength
          if (maxLength) e.target.maxLength = maxLength
          onChange(document.getElementById("editorHtmlContent").firstChild)
        }
      }
    })

  }

  onInputChecbox = (e) => {
    const { onChange, replicToOthersTemplates } = this.props
    this.setState({
      showModalCheckboxCm: {
        isVisible: true,
        target: e.target,
        editAction: ({optionsCheck}) => {
          const getNameInput = e.target.getAttribute('data-name')
          const getParentId = e.target.getAttribute('data-parentid')
          const getParentElement = document.getElementById(getParentId)
          const getInputs = getParentElement.querySelectorAll(`input[name='${getNameInput}']`)

          for (let i = 0; i < getInputs.length; i += 1) {
            getInputs[i].value = optionsCheck[i].value
          }

          onChange(document.getElementById("editorHtmlContent").firstChild)
          replicToOthersTemplates({e, type: 'checkboxCm-values', options: {optionsCheck}})
        },
        addAction: (newText, newValue ) => {

          const getNameInput = e.target.getAttribute('data-name')
          const getParentId = e.target.getAttribute('data-parentid')

          const div = document.createElement('div');
          div.innerHTML = createCheckboxCm({newValue, newText, nameInput: getNameInput, parentId: getParentId})
          const getParentElement = document.getElementById(getParentId)
          getParentElement.append(div.firstElementChild)
          onChange(document.getElementById("editorHtmlContent").firstChild)
          const getChecksCustom = getParentElement.querySelectorAll('span.checkmark')
          this.setPropertiesContextMenu(getChecksCustom)
          replicToOthersTemplates({e, type: 'checkboxCm-add', options: {newValue, newText}})
        },
        deleteAction: ({deleteOptionsCheck}) => {
          const getNameInput = e.target.getAttribute('data-name')
          const getParentId = e.target.getAttribute('data-parentid')
          const getParentElement = document.getElementById(getParentId)
          const getInputs = getParentElement.querySelectorAll(`input[name='${getNameInput}']`)

          for (let i =  getInputs.length - 1; i >= 0; i--){
            const isExist = deleteOptionsCheck.find(item => item.value ===  getInputs[i].value)
            if (!isExist) {
              const getParent = getInputs[i].parentElement.parentElement
              getParent.remove()
            }
          }

          // const allOptions =  e.target.getElementsByTagName('OPTION');
          // for (let i =  e.target.length - 1; i >= 0; i--){
          //   const isExist = deleteOptionsSelect.find(item => item.value ===  e.target.options[i].value)
          //   if (!isExist) {
          //     e.target.removeChild( allOptions[i]);
          //   }
          // }
          onChange(document.getElementById("editorHtmlContent").firstChild)
          replicToOthersTemplates({e, type: 'checkboxCm-delete', options: {deleteOptionsCheck}})
        }

      }
    })
  }

  onHideModal = (typeModal) => {
    this.setState({[`showModal${typeModal}`]: {
      isVisible: false
    }})

  }

  render() {
    const { isMicrositio, isEdit, isAddRemoveElements } = this.props
    const { showModalSelect, showModalInputText, showModalCheckboxCm } = this.state

    return (
      <>
        { isMicrositio && <img src='/assets/img/header-demo.PNG' className='img-demo' /> }
        <div
          id="editorHtmlContent"
          contentEditable={isEdit}
          suppressContentEditableWarning
          onInput={this.onInputChange}
        />
        { isMicrositio && <img src='/assets/img/footer-demo.PNG' className='img-demo' /> }
        { showModalSelect.isVisible && (
          <ModalSelect
            target={showModalSelect.target}
            onHidden={() => this.onHideModal('Select')}
            onEditAction={showModalSelect.editAction}
            onAddAction={showModalSelect.addAction}
            onDeleteAction={showModalSelect.deleteAction}
            isAddRemoveElements={isAddRemoveElements}
          />
        )}
        { showModalInputText.isVisible && (
          <ModalInputText
            target={showModalInputText.target}
            onHidden={() => this.onHideModal('InputText')}
            onContinueAction={showModalInputText.continueAction}
            isAddRemoveElements={isAddRemoveElements}
          />
        )}
        { showModalCheckboxCm.isVisible && (
          <ModalCheckboxCm
            target={showModalCheckboxCm.target}
            onHidden={() => this.onHideModal('CheckboxCm')}
            onEditAction={showModalCheckboxCm.editAction}
            onAddAction={showModalCheckboxCm.addAction}
            onDeleteAction={showModalCheckboxCm.deleteAction}
            isAddRemoveElements={isAddRemoveElements}
          />
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = {
};

export default compose(
  withTranslation(),
  connect(mapStateToProps, mapDispatchToProps)
)(EditorHtml);
